import { 
  AUTH_REQUEST,
  UNAUTHORIZE,
  UPDATE_FILTER,
  GET_FILTER_OPTIONS,
  GET_COORDINATES_PROBLEMS,
  GET_COORDINATES_RESULT,
  CLEAN_FILTER,
  ADD_COORDINATES_PROBLEMS,
  DOWNLOAD_PROBLEMS,
  UPDATE_ORGANIZATIONS_NAMES,
  GET_ORGANIZATIONS,
  UPDATE_CUSTOMER,
} from '../sagas/actions';
import { authorizeSaga, unauthorizeSaga } from '../sagas/auth';
import {
  getCoordinatesProblemsSaga,
  getCoordinateResultSaga,
  addCoordinatesProblemsSaga,
  downloadProblemsSaga
} from '../sagas/load-data';
import {
  updateFilterSaga,
  getFilterOptionsSaga,
  cleanFilter,
  getOrganizationsSaga,
  updateOrganizationsNamesSaga,
  updateCustomerSaga
} from '../sagas/filters';
import { takeLatest, fork, all } from 'redux-saga/effects';

function* authSaga() {
  yield all([
    takeLatest(AUTH_REQUEST, authorizeSaga),
    takeLatest(UNAUTHORIZE, unauthorizeSaga)
  ]);
}

function* coordinatesSaga() {
  yield all([
    takeLatest(GET_COORDINATES_PROBLEMS, getCoordinatesProblemsSaga),
    takeLatest(GET_COORDINATES_RESULT, getCoordinateResultSaga),
    takeLatest(ADD_COORDINATES_PROBLEMS, addCoordinatesProblemsSaga),
    takeLatest(DOWNLOAD_PROBLEMS, downloadProblemsSaga)
  ]);
}

function* filterSaga() {
  yield all([
    takeLatest(UPDATE_FILTER, updateFilterSaga),
    takeLatest(GET_FILTER_OPTIONS, getFilterOptionsSaga),
    takeLatest(CLEAN_FILTER, cleanFilter),
    takeLatest(UPDATE_ORGANIZATIONS_NAMES, updateOrganizationsNamesSaga),
    takeLatest(GET_ORGANIZATIONS, getOrganizationsSaga),
    takeLatest(UPDATE_CUSTOMER, updateCustomerSaga)
  ]);
}

function* sagas() {
  yield fork(authSaga);
  yield fork(coordinatesSaga);
  yield fork(filterSaga);
}

export default sagas;


// WEBPACK FOOTER //
// ./src/config/config-sagas.js